// extracted by mini-css-extract-plugin
export default {"container":"QuickSearch_container__XPIgU","searchIcon":"QuickSearch_searchIcon__-XNRF"};